import { render, staticRenderFns } from "./TournamentStatusEdit.vue?vue&type=template&id=84816140&scoped=true"
import script from "./TournamentStatusEdit.vue?vue&type=script&lang=js"
export * from "./TournamentStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./TournamentStatusEdit.vue?vue&type=style&index=0&id=84816140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84816140",
  null
  
)

export default component.exports